// api.js
// import { useUserData } from "./UserDataProvider";

const API_BASE = "https://aebackend.cp.jku.at";

export async function loginUser(user_code = "new") {
  const res = await fetch(`${API_BASE}/login`, {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user_code }),
  });

  if (!res.ok) {
    throw new Error(`Login failed: ${res.status}`);
  }

  return await res.json(); // { access_token, reported_id }
}

export async function getUserInfo(access_token) {
  const res = await fetch(`${API_BASE}/user-info`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      accept: "application/json",
    },
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch user info: ${res.status}`);
  }

  return await res.json();
}

export async function setUserInfo(access_token, userData) {
  const res = await fetch(`${API_BASE}/user/register`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify(userData),
  });
  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(`Failed to register user: ${res.status} - ${errorData.message}`);
  }

  return await res.json();
}


export async function saveSurveyAnswers(access_token, trace_id, survey_id, answers) {
  const res = await fetch(`${API_BASE}/survey/pos-op/save`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      trace_id,
      survey_id,
      answers,
    }),
  });
  
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(
      `Failed to save survey answers: ${res.status} - ${errorData.message || "Unknown error"}`
    );
  }

  return await res.json();
}

export async function saveTraceStep(access_token, traceStepData) {
  const res = await fetch(`${API_BASE}/trace/step/save`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify(traceStepData),
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(
      `Failed to save trace step: ${res.status} - ${errorData.message}`
    );
  }

  return await res.json();
}

export async function getTopics(access_token) {
  const res = await fetch(`${API_BASE}/topics`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      accept: "application/json",
    },
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(`Failed to fetch topics: ${res.status} - ${errorData.message}`);
  }

  return await res.json();
}


export async function logoutUser(access_token) {
  const res = await fetch(`${API_BASE}/logout`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      accept: "application/json",
    },
  });

  if (!res.ok) {
    const errorData = await res.json();

    // if duplicate jti -> almost always a case, as react almost
    // always sends 2 responces on the useEffect.
    if (
      res.status === 400 &&
      errorData.message &&
      errorData.message.includes("duplicate key value violates unique constraint")
    ) {
      console.warn("Token already logged out. Treating as success.");
      return
    }

    throw new Error(`Logout failed: ${res.status} - ${errorData.message}`);
  }

  return await res.json();
}

export async function getHeadline(topic_id, access_token, language) { 
  const res = await fetch(`${API_BASE}/trace/user/topic/${language}/${topic_id}`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      accept: "application/json",
    },
  });

  if (!res.ok) {
    let errorMessage = `Failed to fetch topic trace: ${res.status}`;
    try {
      const errorData = await res.json();
      if (errorData?.message) {
        errorMessage += ` - ${errorData.message}`;
      }
    } catch {
      // Ignore JSON parse errors
    }
    throw new Error(errorMessage);
  }

  return await res.json();
}


export async function saveRethinking(access_token, rethinkingData) {
  const res = await fetch(`${API_BASE}/trace/rethinking/save`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify(rethinkingData),
  });

  if (!res.ok) {
    let errorMessage = `Failed to save rethinking steps: ${res.status}`;
    try {
      const errorData = await res.json();
      if (errorData?.message) {
        errorMessage += ` - ${errorData.message}`;
      }
    } catch {
      // ignore JSON parsing errors
    }
    throw new Error(errorMessage);
  }

  return await res.json();
}




export async function getSurveyQuestions(access_token, code_survey) {
  const res = await fetch(`${API_BASE}/survey/${code_survey}`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      accept: "application/json",
    },
  });

  if (!res.ok) {
    let errorMessage = `Failed to fetch survey questions: ${res.status}`;
    try {
      const errorData = await res.json();
      if (errorData?.message) {
        errorMessage += ` - ${errorData.message}`;
      }
    } catch {
      // ignore JSON parsing errors
    }
    throw new Error(errorMessage);
  }

  return await res.json();
}


export async function getStatistics(access_token, trace_id) {

  const res = await fetch(`${API_BASE}/trace/user/${trace_id}/stats`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      accept: "application/json",
    },
  });

  if (!res.ok) {
    let errorMessage = `Failed to fetch statistics: ${res.status}`;
    try {
      const errorData = await res.json();
      if (errorData?.message) {
        errorMessage += ` - ${errorData.message}`;
      }
    } catch {
      // ignore JSON parsing errors
    }
    throw new Error(errorMessage);
  }

  return await res.json(); 
}

export async function cancelTrace(access_token, trace_id) {
  const res = await fetch(`${API_BASE}/trace/user/cancel/${trace_id}`, {
    method: "PUT",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      accept: "application/json",
    },
  });

  if (!res.ok) {
    let errorMessage = `Failed to cancel trace: ${res.status}`;
    try {
      const errorData = await res.json();
      if (errorData?.message) {
        errorMessage += ` - ${errorData.message}`;
      }
    } catch {
      // Ignore JSON parse errors
    }
    throw new Error(errorMessage);
  }

  return await res.json();
}


export async function updateUserProfile(access_token, userData) {
  const res = await fetch(`${API_BASE}/user/update`, {
    method: "PUT",
    headers: {
      "Authorization": `Bearer ${access_token}`,
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify(userData),
  });

  if (!res.ok) {
    let errorMessage = `Failed to update user profile: ${res.status}`;
    try {
      const errorData = await res.json();
      if (errorData?.message) {
        errorMessage += ` - ${errorData.message}`;
      }
    } catch {
      // Ignore JSON parse errors
    }
    throw new Error(errorMessage);
  }

  return await res.json();
}

export async function getDashboard() {

  const res = await fetch(`${API_BASE}/trace/stats`, {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  });

  if (!res.ok) {
    let errorMessage = `Failed to fetch dashboard statistics: ${res.status}`;
    try {
      const errorData = await res.json();
      if (errorData?.message) {
        errorMessage += ` - ${errorData.message}`;
      }
    } catch {
      // Ignore JSON parse errors
    }
    throw new Error(errorMessage);
  }

  return await res.json();
}